import axios from 'axios';

const backendHost = window.location.hostname;
const defaultBaseUrl = process.env.NODE_ENV === 'production'
  ? `${window.location.origin}/api`
  : `http://${backendHost}:8080/api`;

const api = axios.create({ 
  baseURL: process.env.REACT_APP_API_URL || defaultBaseUrl,
  timeout: 300000, // 5 minute timeout to allow large excel exports
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request Interceptor for Auth
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => Promise.reject(error));

// Response Interceptor for Global Error Handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === 'Network Error') {
       alert("Network Error: Could not reach the backend server. Please check if your Windows Firewall is blocking port 8080.");
    }
    return Promise.reject(error);
  }
);

export default api;
